export default {
    state: {
      'deviceList': [],
      'deviceColorList': [],
    },
    mutations: {
      'SET_DEVICE_LIST': (state, arr) => {
        state['deviceList'] = arr
      },
      'SET_DEVICE_COLOR_LIST': (state, arr) => {
        state['deviceColorList'] = arr
      },
    },
    actions: {
      SetDeviceList({ commit }, arr) {
        commit('SET_DEVICE_LIST', arr)
      },
      SetDeviceColorList({ commit }, arr) {
        commit('SET_DEVICE_COLOR_LIST', arr)
      }
    }
  }